import { render, staticRenderFns } from "./RolePage.vue?vue&type=template&id=e12b5610&scoped=true&"
import script from "./RolePage.vue?vue&type=script&lang=js&"
export * from "./RolePage.vue?vue&type=script&lang=js&"
import style0 from "./RolePage.vue?vue&type=style&index=0&id=e12b5610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12b5610",
  null
  
)

export default component.exports